import Router from "@core/routing/Router";
import { QueryProvider, ThemeProvider } from "@core/providers";
import { AbilityProvider } from "@core/casl-provider";
import { getUserFromToken } from "@core/utils/auth";
import "./App.css";

const App = () => {
  const currentUser = getUserFromToken();

  return (
    <AbilityProvider initialUser={currentUser}>
      <ThemeProvider>
        <QueryProvider>
          <Router />
        </QueryProvider>
      </ThemeProvider>
    </AbilityProvider>
  );
};

export default App;
